import * as Yup from 'yup';

import useFields from './useFields';
import { FORM_FIELDS } from '../config';
import useRegions from '../utils/useRegions';

const useSchema = () => {
  const f = useFields();
  const { hasTransferConsentField } = useRegions();

  const getFields = (self) => {
    return self.contestFields;
  };

  const Schema = {
    contestFields: {
      FirstName: f.FirstName,
      LastName: f.LastName,
      EmailAddress: f.EmailAddress,
      CountryOfResidence: f.CountryOfResidence,
      MainGenre: f.MainGenre,
      ProfileStatement: f.ProfileStatement,
      AgeStatement: f.AgeStatement,
      ProfessionStatement: f.ProfessionStatement,
      ProductStatement: f.ProductStatement,
      PhotoSkills: f.PhotoSkills,
      VideoSkills: f.VideoSkills,
      PrintStatement: f.PrintStatement,
      PhotoCaption: f.PhotoCaption,
      Media: f.Media,
      DataPrivacyPolicy: f.DataPrivacyPolicy,
      TermsAndConditions: f.TermsAndConditions,
      PhotogalleryConsent: f.PhotogalleryConsent,
      MarketingConsent: f.MarketingConsent,
      CAPTCHA: f.CAPTCHA,
    },
    getSchema: function () {
      const schema = {};

      for (const value of Object.values(getFields(this))) {
        if (value.validation) {
          schema[value.name] = value.validation;
        }
      }
      return Yup.object().shape(schema);
    },
    getInitialValues: function () {
      const initial = {};
      for (const value of Object.values(getFields(this))) {
        initial[value.name] = value.initial;
      }
      return initial;
    },
    getContestKeys: function () {
      const { LANGUAGE } = FORM_FIELDS;
      const addKeys = [LANGUAGE];
      const contestKeys = Object.values(this.contestFields).map((f) => f.name);
      return [...addKeys, ...contestKeys];
    },
  };

  if (hasTransferConsentField()) {
    Schema.contestFields.TransferConsent = f.TransferConsent;
  }

  return { Schema };
};

export default useSchema;
